module.exports = __webpack_public_path__ + "img/baatmannsknop.615f56a2.jpeg";